export const messages = {
  en: {
    shopAccountDetailManage: {
      queryConditions: 'Query Conditions',
      selectAccount: 'Please select account',
      selectDetailType: 'Please select detail type',
      inputOrderId: 'Please enter transaction number',
      query: 'Query',
      reset: 'Reset',
      financialDetails: 'Financial Details',
      detailId: 'Detail ID',
      orderId: 'Transaction ID',
      accountName: 'Account Name',
      detailType: 'Detail Type',
      amount: 'Amount',
      transactionTime: 'Transaction Time',
      remark: 'Remark',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out'
    }
  },
  zh: {
    shopAccountDetailManage: {
      queryConditions: '查询条件',
      selectAccount: '请选择账户',
      selectDetailType: '请选择明细类型',
      inputOrderId: '请输入交易编号',
      query: '查询',
      reset: '重置',
      financialDetails: '财务明细',
      detailId: '明细编号',
      orderId: '交易编号',
      accountName: '账户名称',
      detailType: '明细类型',
      amount: '金额',
      transactionTime: '交易时间',
      remark: '说明',
      transferIn: '转入',
      transferOut: '转出'
    }
  }
}